import { FC } from 'react'
import { roundNumber } from 'builder/utils/roundNumber'
import { DotStyle, Slider } from './styles'
import { Handle } from './Handle'
import { HorizontalSliderProps } from './types'

const shouldHideDot = (dotValue: number, defaultValue: number, min: number, max: number) => {
  const dotValueRounded = roundNumber(dotValue, 2)
  return dotValueRounded !== defaultValue && dotValueRounded !== min && dotValueRounded !== max
}

export const HorizontalSlider: FC<HorizontalSliderProps> = props => {
  const {
    value,
    onChange,
    step,
    min,
    max,
    defaultValue = 0,
    disabled = false,
    isIntermediateDotsDisabled = false,
  } = props

  return (
    <Slider
      disabled={disabled}
      defaultValue={defaultValue}
      value={value}
      step={step}
      min={min}
      max={max}
      handleRender={origin => <Handle disabled={disabled} style={origin.props.style} />}
      onChange={val => {
        if (typeof val === 'number') {
          onChange?.(val)
        }
      }}
      dots
      dotStyle={dotValue => {
        if (isIntermediateDotsDisabled && shouldHideDot(dotValue, defaultValue, min, max)) {
          return {}
        }
        return DotStyle
      }}
    />
  )
}
